// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__Ucy\\+F {
    --header-height: 60px;
    height: var(--header-height);
    background-color: var(--header-background, lightgray);
    padding: var(--header-padding, 10px);
    border-bottom: var(--header-border-bottom, 1px solid darkgray);

    display: flex;
    align-items: center;
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/Frame/Header/Header.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,qDAAqD;IACrD,oCAAoC;IACpC,8DAA8D;;IAE9D,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".header {\r\n    --header-height: 60px;\r\n    height: var(--header-height);\r\n    background-color: var(--header-background, lightgray);\r\n    padding: var(--header-padding, 10px);\r\n    border-bottom: var(--header-border-bottom, 1px solid darkgray);\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__Ucy+F`
};
export default ___CSS_LOADER_EXPORT___;
